import type { AllRouteEndpoints } from "../routeTypes";
export const appSettingsTagDeleteCacheKeys: AllRouteEndpoints[] = [
  "/app_settings/tags_data",
  "/app_settings/all_tags",
];
